import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  delimiters: ['${', '}'],
  setup() {
    const store = useStore();
    store.dispatch('getCustomerOverview');
  },
  data() {
    return {
      name: null,
      email: null,
      accountId: null,
      shipping: null,
      billing: null,
    };
  },
  mounted() {
    const store = useStore();
    this.name = computed(() => store.state.customerOverview.name);
    this.email = computed(() => store.state.customerOverview.email);
    this.accountId = computed(() => store.state.customerOverview.accountId);
    this.shipping = computed(() => store.state.customerOverview.shipping);
    this.billing = computed(() => store.state.customerOverview.billing);
  },
  template: '#t-customer-overview',
});
